export const ROUTES = {
  HOME: '/',
  DONATE: '/get-involved/donate',
  GETINVOLVED: '/get-involved',
  ABOUT: '/about',
  FOUNDERMESSAGE: '/founder-message',
  OURTEAM: '/our-team',
  FREEGROCERY: '/free-grocery-for-widows-and-senior-citizen',
  QURBANIUDHIYASADAQAHOBLIGATIONS: '/sadaqah-udhiya-qurbani-obligations',
  APNAROZGAR: '/apna-rozgar',
  THANKS: '/thanks',
  QTHANKS: '/qurbani/thanks',
  SCHOOLS: '/basic-schools',
  WATERHANDPUMPS: '/water-hand-pumps',
  MEDICALSUPPORT: '/medical-support',
  VIDEOS: '/videos',
  FLOODVICTIMSP: '/relief-for-flood-victims-in-pakistan',
  FLOODVICTIMSPAKI: '/relief-for-flood-victims-in-pakistan-by-sjwf',
  FLOODVICTIMSPAKISTAN: '/relief-efforts-for-flood-victims-in-pakistan',
  HELPINGANORPHAN: '/helping-an-orphan',
  PROJECTS20222024: '/projects-2022-24',
  PROJECTS_FINANCIALMONTHLYSUPPORT: '/projects/financial-monthly-support',
  PROJECTS_MONTHLYRATIONSUPPORT: '/projects/monthly-ration-support',
  PROJECTS_SMALLBUSINESSPROGRAM: '/projects/small-business-program',
  PROJECTS_TECHNICALCENTERFOREMPOWERINGWOMEN:
    '/projects/technical-center-for-empowering-women',
  PROJECTS_EDUCATIONPROGRAM: '/projects/education-program',
  PROJECTS_MEDICALPROGRAM: '/projects/medical-program',
  PROJECTS_CLEANWATERPROJECTS: '/projects/clean-water-projects',

  WOMENS_VOCATIONAL_TRAINING: '/womens-vocational-training',
  HEATSTROKE_RELIEF_CAMPS: '/heatstroke-relief-camps',
  ORPHAN_MARRIAGE_ASSISTANCE: '/orphan-marriage-assistance',
};
